// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3CtIR","filesListContainer":"PosDisputesFiles_filesListContainer__28JVi","filesButton":"PosDisputesFiles_filesButton__1zrNd"};